import { useTranslations } from "use-intl";
import type { EnglishMessages } from "@financialharmony/i18n/messageTypes";
import { hasMessageKey } from "@/i18n/hasMessageKey";

type SourceKey = keyof EnglishMessages["consultantBooks"]["journal"]["sources"];

/** The words for where a journal entry came from; a source the catalog does not know shows as it is. */
export function useJournalSourceLabel() {
  const t = useTranslations("consultantBooks.journal.sources");
  return (sourceType: string) => (hasMessageKey<SourceKey>(t, sourceType) ? t(sourceType) : sourceType);
}
